import script from "./SystemParameterView.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemParameterView.vue?vue&type=script&setup=true&lang=js"

import "./SystemParameterView.vue?vue&type=style&index=0&id=c4157548&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4157548"]])

export default __exports__